module.exports = __webpack_public_path__ + "img/winona-card.beb32d01.png";